module.exports = __webpack_public_path__ + "static/media/monster.43f94980.png";